import { Container, CreateTableState, Grid, Icon, Typography } from 'gu-ui-kit'
import React from 'react'
import format from 'utils/dateFns/format'
import styles from 'modules/Finance/PaymentProfiles/List/subcomponents/List/payment-profiles-list.module.scss'
import { Link } from 'react-router-dom'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { ROUTES } from 'constants/routes'
import StatusIcon from 'modules/Finance/PaymentProfiles/List/subcomponents/StatusIcon'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useTranslation } from 'react-i18next'

export const useTableConfig = ({ className, ...rest }, data = []) => {
  const breakpoints = useBreakpoint()
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()

  const tableConfig = {
    className,
    state: {
      columnVisibility: {},
    },
    columns: [
      {
        id: 'name',
        cell: ({
          // eslint-disable-next-line react/prop-types
          row: {
            // eslint-disable-next-line react/prop-types
            original: { is_archived, status, id, title, contract, method, decline_reason },
          },
        }) => (
          <Grid
            gap={16}
            wrap={false}
          >
            <div>
              <StatusIcon
                status={is_archived ? 'declined' : status}
                breakpoints={breakpoints}
              />
            </div>
            <Container className={styles['word-break-container']}>
              <Typography
                noMargin
                color={'Interface-Eighth'}
                variant={breakpoints.sm ? 'Body-15' : 'Body-30'}
                component={
                  status !== 'new' ? (
                    <Link
                      to={pathGen(ROUTES.FINANCE_PAYMENT_PROFILE_INVOICES, {
                        profileId: id,
                      })}
                      className={styles['row__title']}
                    >
                      {title}
                    </Link>
                  ) : (
                    <p>{title}</p>
                  )
                }
              />

              <Container
                display={'flex'}
                flexAlign={'center'}
                flexWrap={'wrap'}
              >
                {contract?.number && (
                  <>
                    <Typography
                      variant={breakpoints.sm ? 'Body-10' : 'Body-15'}
                      component={'span'}
                      noMargin
                      color={'Label-Secondary'}
                    >
                      {contract.number}
                      {contract?.date && ` ${t('common::dated')} ` + format(contract.date * 1000)}
                    </Typography>{' '}
                    <Icon
                      name={'dot'}
                      size={'s'}
                      color={'Label-Secondary'}
                    />
                  </>
                )}
                <Typography
                  variant={breakpoints.sm ? 'Body-10' : 'Body-15'}
                  component={'span'}
                  noMargin
                  color={'Label-Secondary'}
                >
                  {t(`common::payment_methods.${method}`)}
                </Typography>{' '}
                <Icon
                  name={'dot'}
                  size={'s'}
                  color={'Label-Secondary'}
                />
                <Typography
                  variant={breakpoints.sm ? 'Body-10' : 'Body-15'}
                  component={'span'}
                  noMargin
                  color={'Label-Secondary'}
                >
                  {is_archived
                    ? t(`payment_profiles::is_archived`)
                    : t(`payment_profiles::statuses.${status}`)}

                  {status === 'declined' && (
                    <span>
                      : <span className={styles['decline_reason']}>{decline_reason}</span>
                    </span>
                  )}
                </Typography>
              </Container>
            </Container>
          </Grid>
        ),
      },
      {
        id: 'action',
        cell: ({
          row: {
            original: { status, id },
          },
        }) =>
          status !== 'new' && (
            <div>
              {status === 'declined' ? (
                <Link
                  to={pathGen(ROUTES.FINANCE_PAYMENT_PROFILE_EDIT, {
                    profileId: id,
                  })}
                  title={t('common::button_labels.edit')}
                >
                  <Icon
                    name={'refresh'}
                    size={'m'}
                    color={'secondary-46'}
                  />
                </Link>
              ) : (
                <Link
                  to={pathGen(ROUTES.FINANCE_PAYMENT_PROFILE_INVOICES, {
                    profileId: id,
                  })}
                  title={t('payment_profiles::go_to_invoices')}
                >
                  <Icon
                    name={'doc'}
                    size={'m'}
                    color={'Label-GU-Primary'}
                  />
                </Link>
              )}
            </div>
          ),
      },
    ],
    showHeader: false,
    showFooter: false,
    ...rest,
  }

  return {
    tableState: CreateTableState(tableConfig, data),
    tableConfig,
  }
}
